import 'handsontable';
import formatters from '../../../Gull/Framework/formatters.js';

const Handsontable = window.Handsontable;

var HandsontableRenderers = {

	init: function() {

		// Salary renderer
		window.Handsontable.renderers.registerRenderer('bedrag', function(instance, td, row, col, prop, value) {
			window.Handsontable.renderers.BaseRenderer.apply(this, arguments);
			td.innerHTML = formatters.currencyEuroSign(value);
			return td;
		});

		// Percentage renderer
		window.Handsontable.renderers.registerRenderer('percentage', function(instance, td, row, col, prop, value) {
			window.Handsontable.renderers.BaseRenderer.apply(this, arguments);
			if (value == null) {
				td.innerHTML = '';
			} else {
				if (value > 100) {
					value = 100;
				} else if (value < 0) {
					value = 0;
				}
				td.innerHTML = formatters.percentage(value);
			}
			return td;
		});

	}

};

export default HandsontableRenderers;
